import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';

import styles from './Footer.styles';

import { ClassProp } from 'helpers/types';

type Props = {
  classes: ClassProp<typeof styles>;
};
const date = new Date();

const Footer: FunctionComponent<Props> = ({ classes }) => (
  <footer className={classes.footer}>
    <div className={classes.copyRight}>
      Copyright Dosh Holdings LLC {date.getFullYear()}
    </div>
  </footer>
);

export default withStyles(styles)(Footer);
